import moment from 'moment';

import { Section } from '../../../../../Model/CoachNotificationView';

const checkIsPriorityNotification = (oldestNotificationAtSeconds, section) => {
  if (!oldestNotificationAtSeconds) {
    return false;
  }

  const diffInHours = moment().diff(moment.unix(oldestNotificationAtSeconds), 'hours');

  switch (section) {
    case Section.CHECKINS:
      return diffInHours > 48;
    default:
      return diffInHours > 24;
  }
};

export { checkIsPriorityNotification };
